package game.entity

import TentacleWall
import com.soywiz.kds.iterators.fastForEach
import com.soywiz.korma.geom.PointInt
import game.Game
import game.Room

class KrakenBattle : Entity() {
    private var step = 0
    private var delay = 0
    private var currentTentacle = 0

//    var hp = 8
    private val wall = TentacleWall().apply {
        col = 23
        row = 11
    }
    private val door = Door().apply {
        col = 27
        row = 20
    }

    private val tentacleVectors = arrayOf(
        PointInt(7, 13),
        PointInt(14, 15),
        PointInt(21, 13),
        PointInt(33, 14),
        PointInt(41, 13),
    )

    private val headVectors = arrayOf(
        PointInt(5, 11),
        PointInt(14, 13),
        PointInt(32, 12),
        PointInt(39, 11),
    )

    private val bubbles = arrayOf(
        AnimationEntity().apply {
            params = "bubble"
            col = 3
            row = 12
        },
        AnimationEntity().apply
        {
            params = "bubble"
            col = 8
            row = 13
        },
        AnimationEntity().apply
        {
            params = "bubble"
            col = 11
            row = 14
        },
        AnimationEntity().apply
        {
            params = "bubble"
            col = 14
            row = 13
        },
        AnimationEntity().apply
        {
            params = "bubble"
            col = 17
            row = 14
        },
        AnimationEntity().apply
        {
            params = "bubble"
            col = 20
            row = 13
        },
        AnimationEntity().apply
        {
            params = "bubble"
            col = 22
            row = 14
        },
        AnimationEntity().apply
        {
            params = "bubble"
            col = 28
            row = 12
        },
        AnimationEntity().apply
        {
            params = "bubble"
            col = 32
            row = 13
        },
        AnimationEntity().apply
        {
            params = "bubble"
            col = 35
            row = 14
        },
        AnimationEntity().apply
        {
            params = "bubble"
            col = 38
            row = 12
        },
        AnimationEntity().apply
        {
            params = "bubble"
            col = 43
            row = 13
        },
        AnimationEntity().apply
        {
            params = "bubble"
            col = 47
            row = 14
        },
    )

    private val head = KrakenHead().apply {
        onDone = {
            step = 7
        }
        onHit = {
            hp--
        }
    }

    override fun onInit(game: Game, room: Room) {
    }

    override fun onRemove(game: Game, room: Room) {
        room.removeEntity(wall)
    }

    override fun onTick(game: Game, room: Room) {
        when (step) {
            0 -> {
                if (game.player.row <= 15) {
                    startBattle(game, room)
                    step++
                }
            }
            1 -> {
                bubbles.fastForEach { room.addEntity(it) }
                bubbles[0].onAnimationComplete = { step++ }
                step++
            }
            2 -> {
                // Wait for bubbles to go away and prepare attack
                currentTentacle = 0
                tentacleVectors.shuffle()
            }
            3 -> {
                room.addEntity(Tentacle().also {
                    it.startAttack()
                    it.col = tentacleVectors[currentTentacle].x
                    it.row = tentacleVectors[currentTentacle].y
                })
                game.playSound("splash")
                step++
                currentTentacle++
                delay = 20
            }
            4 -> {
                delay--

                if (delay == 0) {
                    if (currentTentacle == tentacleVectors.size) {
                        step++
                    } else {
                        step = 3
                    }
                }
            }
            5 -> {
                headVectors.shuffle()
                head.col = headVectors[0].x
                head.row = headVectors[0].y
                room.addEntity(head)
                step++
            }
            6 -> {
                // Wait for head to be done...
            }
            7 -> {
                if (head.hp <= 0) {
                    head.killMe(game)
                    room.removeEntity(door)
                    room.removeEntity(wall)
                    room.removePermanently(game, this)
                }
                step = 1
            }
        }
    }

    private fun startBattle(game: Game, room: Room) {
        room.addEntity(wall)
        room.addEntity(door)
        game.playSound("splash")
    }
}